import { RETRAINING_ACTION as ACTION_TYPE } from '../types/actionTypes';
const setTrainingStatus = dispatch => status => dispatch({
  type: ACTION_TYPE.SET_TRAINING_STATUS,
  payload: {
    trainingStatus: status
  }
});
const setNotEnoughThemesCreated = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_NOT_ENOUGH_THEMES_CREATED,
  payload: {
    notEnoughThemesCreated: val
  }
});
const setNotEnoughThemesCreatedStep = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_NOT_ENOUGH_THEMES_CREATED_STEP,
  payload: {
    notEnoughThemesCreatedStep: val
  }
});
// sometimes we need to update multiple state values at once
const setMultiple = dispatch => payload => dispatch({
  type: ACTION_TYPE.SET_MULTIPLE,
  payload
});
export default {
  setTrainingStatus,
  setNotEnoughThemesCreated,
  setNotEnoughThemesCreatedStep,
  setMultiple
};